import React from "react";
import { useMeasure } from "react-use";
import { extractAnimatedHeightProps } from "./util";
import { useIsFirstRender } from "@hooks/index";
import { useSpringReveal, useAnimatedWrapper } from '@components/animatedHeight';

export const AnimatedHeightWithRef = (props) => {
  const {children, element, innerProps, outerProps, initialHeight} = extractAnimatedHeightProps(props);
  const [ref, {height}] = useMeasure();
  const isFirstRender = useIsFirstRender();
  const addressSpring = useSpringReveal(isFirstRender && initialHeight ? initialHeight : height);
  const AnimatedWrapper = useAnimatedWrapper(element);
  const { style = {}, ...otherAnimatedProps } = outerProps || {};

  return (
    <AnimatedWrapper {...otherAnimatedProps} style={{...style, overflow: 'hidden', ...addressSpring}}>
      {children({ref, ...innerProps})}
    </AnimatedWrapper>
  );
};